import { useState } from 'react';

export default function CopyBlock({ copyText, children }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Błąd kopiowania', err);
    }
  };

  return (
    <div className="copy-container" onClick={handleCopy}>
      <div className="copy-text">{children}</div>
      <span className="copy-icon" aria-label="Kopiuj">
        {copied ? '✅' : '📋'}
        <span className="tooltip">{copied ? 'Skopiowano!' : 'Kliknij, aby skopiować'}</span>
      </span>
    </div>
  );
}
